/**
 * Outline SVG icon module.
 */
import * as React from "react";
/**
 * Collection (outline) SVG icon. Generated wrapper that forwards props to the root svg.
 *
 * @param {React.SVGProps<SVGSVGElement>} props SVG element props.
 * @returns {JSX.Element}
 */
const SvgCollection = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M49 41H35m14 0a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H35a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2m14 0v-2a2 2 0 0 0-2-2m-12 4v-2a2 2 0 0 1 2-2m10 0v-2a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2v2m10 0H37"
    />
  </svg>
);
export default SvgCollection;
